import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'roleFormat',
    standalone: true
})
export class RoleFormatPipe implements PipeTransform {
    private readonly ROLE_MAP: Record<string, string> = {
        'ROLE_ADMIN': 'Admin',
        'ROLE_RESP_AFFAIRE': "Responsable d'affaire",
        'ROLE_CONTROLEUR': 'Contrôleur',
        'ROLE_SOUS_TRAITANT': 'Sous-traitant'
    };

    transform(value: any): string {
        const roleName = typeof value === 'string' ? value : value?.name || '';

        if (!roleName) return 'N/A';

        // Check if we have a direct mapping
        if (this.ROLE_MAP[roleName]) {
            return this.ROLE_MAP[roleName];
        }

        // Fallback: remove ROLE_ and replace underscores with spaces, capitalize
        return roleName
            .replace('ROLE_', '')
            .split('_')
            .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    }
}
